import css from 'styled-jsx/css';

export default css`
  @import '../../styles/colors.scss';
  .checkbox-wrapper label {
    cursor: pointer;
    display: flex;
    align-items: start;
  }
  .checkbox-wrapper input[type='checkbox'] {
    -webkit-appearance: none;
    appearance: none;
    min-width: 20px;
    min-height: 20px;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    border: 1px solid $color--grey4;
    border-radius: 2px;
    outline: none;
    cursor: pointer;
    background-color: $color--white;
  }
  .checkbox-wrapper input[type='checkbox']:focus {
    border: 1px solid $color--movistar_blue;
    outline: 1px solid black;
    outline-width: 1px;
    outline-style: auto;
  }
  input.checked {
    background-color: $color--movistar_blue !important;
    border: 1px solid $color--movistar_blue !important;
    position: relative;
  }
  input.error {
    border: 1px solid $color--red !important;
  }
  .checkbox-wrapper input[type='checkbox'] .checked {
  }

  input.checked::before {
    content: '';
    display: block;
    width: 13px;
    height: 7px;
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    -webkit-transform: rotate(315deg);
    -ms-transform: rotate(315deg);
    transform: rotate(315deg);
    position: absolute;
    top: 4px;
    left: 3px;
    background-color: transparent;
  }

  :global(.checkbox-wrapper_error) {
    padding: 2px 0 0 30px;
  }
  .hidden-checkbox {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }
  .checkbox-wrapper input:focus + .labelText {
    border: 0;
    outline: 1px solid black;
    outline-width: 1px;
    outline-style: auto;
  }
`;
